<template>
  <widget
    @closed="$emit('closed')"
    title="totale lavoratori retribuiti"
    icon="mdi-account-group"
    :bgColor="colors.orange"
    dark
  >
    <v-row class="text-little" no-gutters>
      <v-col cols="3" class="align-stretch">
        <v-card outlined flat tile height="100%">
          <div
            class="d-flex justify-center head align-center"
            style="height: 100%"
          >
            Tipologia
          </div>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card outlined flat tile>
              <div class="text-center head text-truncate">Determinato</div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center head">Full Time</div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center head">Part Time</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card outlined flat tile>
              <div class="text-center head text-truncate">Indeterminato</div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center head">Full Time</div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center head">Part Time</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card outlined flat tile>
              <div class="text-center head">Totale</div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center head">Full Time</div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center head">Part Time</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      class="text-caption"
      no-gutters
      v-for="(row, index) in item.righe"
      :key="index"
    >
      <v-col cols="3">
        <v-card outlined flat tile>
          <div class="font-weight-black pl-1 text-truncate">
            {{ row.tipologia }}
          </div>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center">{{ row.detFT }}</div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center">{{ row.detPT }}</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center">{{ row.indFT }}</div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center">{{ row.indPT }}</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center font-weight-black">
                {{ row.totFT }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center font-weight-black">
                {{ row.totPT }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="text-caption" no-gutters>
      <v-col cols="3">
        <v-card outlined flat tile>
          <div class="font-weight-black pl-1 text-truncate">Collaboratori</div>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-row no-gutters>
          <v-col cols="6">
            <v-card outlined flat tile>
              <div class="text-center">{{ item.collaboratori }}</div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="9">
        <div class="text-right font-weight-black text-caption text-sm-overline">
          Totale generale lavoratori
        </div>
      </v-col>
      <v-col cols="3">
        <div
          class="text-center font-weight-black text-caption text-sm-overline"
        >
          {{ item.totaleLavoratori }}
        </div>
      </v-col>
    </v-row>
  </widget>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Widget from "./Widget.vue";
import mixin from "@/mixin";

export default {
  name: "forza-aziendale-home-widget",
  mixins: [mixin],
  components: {
    Widget,
  },
  mounted() {
    this.fethData();
  },
  destroyed() {
    this.resetData();
  },
  methods: {
    ...mapActions({
      fethData: "widget/fetchCompanyEmployees",
      resetData: "widget/resetCompanyEmployees",
    }),
  },
  computed: {
    ...mapGetters({
      item: "widget/companyEmployees",
    }),
  },
};
</script>

<style>
</style>